<template>
  <v-select
    v-bind="{ ...$props, ...$attrs }"
    variant="outlined"
    :rules="getRules"
    :bg-color="backgroundColor"
  >
    <template v-if="withIcons" #item="{ props, item }">
      <v-list-item v-bind="props">
        <template #prepend>
          <v-icon>
            {{ item.raw.icon }}
          </v-icon>
        </template>
      </v-list-item>
    </template>
    <template v-if="withIcons" #selection="{ item }">
      <v-row>
        <v-col cols="1">
          <v-icon>
            {{ item.raw.icon }}
          </v-icon>
        </v-col>
        <v-col class="d-flex align-center ps-8">
          {{ item.raw[itemTitle] }}
        </v-col>
      </v-row>
    </template>
  </v-select>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "TSelect",

  props: {
    backgroundColor: {
      type: String,
      default: "white",
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredErrorMessage: {
      type: String,
      default: "Este campo é obrigatório",
    },
    rules: {
      type: Array as PropType<((v: string | number) => boolean | string)[] | []>,
      default: () => [],
    },
    withIcons: {
      type: Boolean,
      default: false,
    },
    itemTitle: {
      type: String,
      default: "title",
    },
    itemValue: {
      type: String,
      default: "value",
    },
  },

  computed: {
    getRules(): ((v: string | number) => boolean | string)[] | [] {
      const required = this.required ? [ (v: string | number) => !!v || this.requiredErrorMessage ] : [];

      return [...this.rules, ...required];
    },
  },
});
</script>
